import {produce} from "immer";
import {SETBOOK} from "../actions/book";
import {SETBOOKDETAILS} from "../actions/book";
import {SETORDERBOOKINGDETAILS} from "../actions/book";
import {SETSHIPMENTPAYMENT} from "../actions/book";
import {SETTEMPLEDETAILS} from "../actions/book";

// --- HELPERS FOR SESSION ---
const saveToSession = (data) => {
    sessionStorage.setItem("myBookCart", JSON.stringify(data));
};

const loadFromSession = () => {
    const saved = sessionStorage.getItem("myBookCart");
    // If we have saved books, use them. Otherwise, start with empty array []
    return saved ? JSON.parse(saved) : [];
};

const INITIAL_STATE = {
    bookList: [],
    bookDetails: {},
    bookOrderDetails: loadFromSession(), // Now loads from Session on startup
    shippingCharges: [],
    templeDetails: [],
}

export const bookReducer = produce((draft, action) => {
    switch (action.type) {
        case SETBOOK:
            draft.bookList = action.payload;
            break;
        case SETBOOKDETAILS:
            draft.bookDetails = action.payload;
            break;
        case SETORDERBOOKINGDETAILS:
            if (Array.isArray(action.payload) && action.payload.length === 0) {
                draft.bookOrderDetails = [];
            } else if (action.payload.shippingDetails) {
                draft.shippingDetails = action.payload.shippingDetails;
            } else {
                const { BookName, Amount, BookID, increment, decrement, remove } = action.payload;
                const bookIndex = draft.bookOrderDetails.findIndex((book) => book.BookID === BookID);

                if (remove) {
                    if (bookIndex !== -1) {
                        draft.bookOrderDetails.splice(bookIndex, 1);
                    }
                } else if (bookIndex === -1 && increment) {
                    draft.bookOrderDetails.push({ BookName, Amount, BookID, Copy: 1 });
                } else if (bookIndex !== -1) {
                    if (increment) {
                        draft.bookOrderDetails[bookIndex].Copy += 1;
                    } else if (decrement && draft.bookOrderDetails[bookIndex].Copy > 0) {
                        draft.bookOrderDetails[bookIndex].Copy -= 1;
                        if (draft.bookOrderDetails[bookIndex].Copy === 0) {
                            draft.bookOrderDetails.splice(bookIndex, 1);
                        }
                    }
                }
            }
            // --- AUTO-SAVE TO SESSION ---
            // This ensures that every time the list changes, it's backed up.
            saveToSession(draft.bookOrderDetails);
            break;

        case SETSHIPMENTPAYMENT:
            draft.shippingCharges = action.payload;
            break;
        case SETTEMPLEDETAILS:
            draft.templeDetails = action.payload;
            break;
        default:
            return draft;
    }
}, INITIAL_STATE);